/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { conformToMask } from "@monsma/App/Libraries/text-mask-core";

/**
 * text-mask-core, react-text-mask apply method
 *
 * how to create your custom mask
 * https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#readme
 *
 * @param {*} newValue
 * @param {*} oldValue
 * @param {*} pattern
 * @returns
 */
export const commitMask = (newValue: string, oldValue: string, pattern: any) => {
    const result = conformToMask(newValue, pattern, { guide: false });
    // TODO: find way to make old value not needed, its just needed on delete
    if (result.meta.someCharsRejected || oldValue.length < newValue.length) {
        return result.conformedValue;
    }

    return newValue;
};

/**
 * Regex Patterns
 */
export const xPatterns = {
    phone: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
    shortZipCode: [/\d/, /\d/, /\d/, /\d/, /\d/],
    longZipCode: [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
};

export default xPatterns;
